import { format } from 'date-fns'

import { DATE_FULL_FORMAT_FROM_TIME } from '../../../../../../constants/date'
import { toUkTimezoneDate } from '../../../../../../utils/date'
import { NEWSBOARD_TYPES_KEYS } from '../../../../Newsboard.constants'

function getDateTimeContent({ created, date_from, date_to, ukLocaleTimeZone }) {
  if (date_from) {
    return date_to
      ? `${format(
          toUkTimezoneDate(date_from, ukLocaleTimeZone.timezone),
          DATE_FULL_FORMAT_FROM_TIME
        )} - ${format(
          toUkTimezoneDate(date_to, ukLocaleTimeZone.timezone),
          DATE_FULL_FORMAT_FROM_TIME
        )}`
      : format(
          toUkTimezoneDate(date_from, ukLocaleTimeZone.timezone),
          DATE_FULL_FORMAT_FROM_TIME
        )
  }

  return created
    ? format(
        toUkTimezoneDate(created, ukLocaleTimeZone.timezone),
        DATE_FULL_FORMAT_FROM_TIME
      )
    : null
}

export function parsePostData(data, ukLocaleTimeZone) {
  return {
    status: data.status,
    time: getDateTimeContent({ ...data, ukLocaleTimeZone }),
    typeKey: NEWSBOARD_TYPES_KEYS[data.post_type_category],
  }
}
